import './toast.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Wrapper = forwardRef((props, ref) => {
  const className = classNames({
    toast: true,
    fade: true,
    show: props.visible,
    [`toast-${props.type}`]: props.type,
    [props.className]: props.className,
  });

  const classNameWrapper = classNames({
    [`toast-${props.placement}`]: props.placement,
  });

  return (
    <div className={classNameWrapper}>
      <div ref={ref} className={className} role="alert" aria-live="assertive" aria-atomic="true">
        {props.children}
      </div>
    </div>
  );
});

Wrapper.propTypes = {
  type: PropTypes.oneOf(['success', 'warning']),
  placement: PropTypes.oneOf(['top', 'top-right', 'top-left']),
  visible: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

Wrapper.defaultProps = {
  placement: 'top',
};

const Header = forwardRef((props, ref) => {
  const className = classNames({
    'toast-header': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} role="alert" aria-live="assertive" aria-atomic="true">
      {props.children}
    </div>
  );
});

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Body = forwardRef((props, ref) => {
  const className = classNames({
    'toast-body': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} role="alert" aria-live="assertive" aria-atomic="true">
      <p className="mb-0">{props.children}</p>
    </div>
  );
});

Body.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Footer = forwardRef((props, ref) => {
  const className = classNames({
    'toast-footer': true,
    'mt-1': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} role="alert" aria-live="assertive" aria-atomic="true">
      {props.children}
    </div>
  );
});

Footer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Toast = { Wrapper, Header, Body, Footer };

export default Toast;
